import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { FormRowComponent } from './form-row.component'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { AlertModule } from '@shared/components/alert/alert.module'

@NgModule({
  declarations: [FormRowComponent],
  imports: [
    CommonModule,
    SweetAlert2Module.forRoot(),
    BrowserAnimationsModule,
    RouterModule,
    TranslateModule,
    AlertModule,
  ],
  exports: [FormRowComponent],
})
export class FormRowModule {}
